import React, { useState, useEffect, useRef } from 'react';
import { formatMoneda } from '../../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import useTableScroll from '../../useTableScrollcesar';
import { Mensaje, MensajeSiNo } from '../../mensajes2';

import { Dimmer} from "../../spinner";

const TablaDeudaContrixTransaccion = (props) => {

    var op = require('../../../../src/modulos/datos')
    let token = localStorage.getItem('jwtToken');

    const headCells = [
        { label: 'Año', textAlign: 'center' },
        { label: 'Mes', textAlign: 'center' },
        { label: 'Monto', textAlign: 'center' },
        { label: 'Interes Mora', textAlign: 'center' },
        { label: 'Recargo', textAlign: 'center' },
        { label: 'Multa', textAlign: 'center' },
        { label: 'Descuento', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead
    } = useTableScroll(headCells);

    const [mostrar2, setMostrar2] = useState(false);
    const [anio, setAnio] = useState([]);
    const [anios, setAnios] = useState();
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [fechas, setFechas] = useState();
    const [mes, setMes] = useState();
    const txtAnio = useRef();
    const [operacion, setOperacion] = useState(1);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

    const [totImpu, setTotImpu] = useState(0.00);
    const [totFact, setTotFact] = useState(0.00);
    const [totInt, setTotInt] = useState(0.00);
    const [totRec, setTotRec] = useState(0.00);
    const [totMulta, setTotMulta] = useState(0.00);
    const [descue, setDescue] = useState(0.00);
    const [deduci, setDeduci] = useState(0.00);
    const [disableBot, setDisableBot] = useState(false);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    useEffect(() => {

        if (props.factura && props.deuda) {
            if (props.factura.idcontribuyente === "0" || props.factura.idcontribuyente === null || props.factura.tabladeuda.trim() === 'publicidad' || props.factura.tabladeuda.trim() === 'licores' || props.factura.tabladeuda.trim() === 'multa') {
                setTotImpu(props.factura.totalinmpuesto);
                setTotFact((parseFloat(props.factura.totalinmpuesto)+parseFloat(props.factura.totalinteres)+parseFloat(props.factura.totalrecargo)).toFixed(2));
                setTotInt(props.factura.totalinteres);
                setTotRec(props.factura.totalrecargo);
                setTotMulta(props.factura.totalmulta);
                setDeduci(props.factura.deducible);
            } else {
                setRecords(props.deuda);
                let impu = 0.00;
                let inte = 0.00;
                let reca = 0.00;
                let mult = 0.00;
                let totdeu = 0.00;
                for (let i = 0; i < props.deuda.length; i++) {
                    impu = parseFloat(impu) + parseFloat(props.deuda[i].montoimpuesto);
                    inte = parseFloat(inte) + parseFloat(props.deuda[i].montointeres);
                    reca = parseFloat(reca) + parseFloat(props.deuda[i].montorecargo);
                    mult = parseFloat(mult) + parseFloat(props.deuda[i].montomulta);
                }
                totdeu = impu + inte + reca + mult - parseFloat(props.factura.deducible);
                setTotImpu(impu);
                setTotFact(totdeu);
                setTotInt(inte);
                setTotRec(reca);
                setTotMulta(mult);
                setDeduci(props.factura.deducible);
                /*if (totdeu !== props.factura.totalfactura) {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No se puede procesar la transacción Hay diferencia entre el monto facturado y la deuda actual', icono: 'informacion' });
                }*/
            }
        };

    }, [props.factura, props.deuda]);

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    }

    return (
        <div className=''>
            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
            <div className="m-0" >
                <TblContainer container={{ height: 110, maxHeight: 180, width: '100%', overflow: 'auto' }}>
                    <TblHead />
                    <tbody>
                        {records && records.map((deu, index) => (

                            <tr key={index} >

                                <td className='p-0 text-center'>{deu.anio}</td>
                                <td className='p-0 text-center'>{deu.mes}</td>
                                <td className='p-0 text-end'>{formatMoneda(deu.montoimpuesto.replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                <td className='p-0 text-end'>{formatMoneda(deu.montointeres.replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                <td className='p-0 text-end'>{formatMoneda(deu.montorecargo.replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                <td className='p-0 text-end'>{formatMoneda(deu.montomulta.replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                <td className='p-0 text-end'>{formatMoneda(deu.montodescuento.replace(',', '').replace('.', ','), ',', '.', 2)}</td>

                            </tr>

                        ))}
                    </tbody>
                </TblContainer>
            </div>
            <div className='row col-12 p-0 m-0 border-table' style={{ borderTopStyle: 'hidden' }}>
                <table>
                    <tbody>
                        <tr>
                            <td className=''><p style={{ fontWeight: 'bold' }}>{'Monto: ' + formatMoneda(totImpu.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</p></td>
                            <td className=''><p style={{ fontWeight: 'bold' }}>{'Interes: ' + formatMoneda(totInt.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</p></td>
                            <td className=''><p style={{ fontWeight: 'bold' }}>{'Recargo: ' + formatMoneda(totRec.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</p></td>
                            <td className=''><p style={{ fontWeight: 'bold' }}>{'Multa: ' + formatMoneda(totMulta.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</p></td>
                            <td className=''><p style={{ fontWeight: 'bold' }}>Descuento: 0,00</p></td>
                            <td className=''><p style={{ fontWeight: 'bold' }}>{'Total: ' + formatMoneda(totFact.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</p></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div >
    );
}
export default TablaDeudaContrixTransaccion;
